import createPointerArrowBtn from '../../common/createPointerArrowBtn/index';
import classes from './styles.module.css';

/**
 * This function returns single card component
 *
 * @param {Object} config - story data
 * @returns {HTMLElement} - story card
 */
const createStoryCard = config => {
    const {title = '', src = '', width = '100%', height = 'auto', id} = config;

    return `<div class="${classes.storyCard} story-card" data-item-id="${id}">
    <div class="${classes.cardHeader} story-header pointer-events-none">
        <section class="${classes.cardTitle} card-title">${title}</section>
        <div class="${classes.cardLink} card-link">${createPointerArrowBtn({
        htmlStr: true,
        iconOnly: true
    })}</div>
    </div>
    <div class="${classes.cardContent} card-content pointer-events-none">
        <img
        src="${src}"
        alt=""
        loading="lazy"
        fetchpriority="low"
        width="${width}"
        height="${height}"
        class="${classes.cardImage} card-image"
    />
    </div>
    </div>`;
};

export default createStoryCard;
